import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

import { ReactComponent as Edit } from 'assets/svg/edit-icon.svg';
import { ReactComponent as Delete } from 'assets/svg/delete-icon.svg';
import { ReactComponent as Group } from 'assets/svg/group-icon.svg';
import { ReactComponent as People } from 'assets/svg/people-icon.svg';
import { ReactComponent as Settings } from 'assets/svg/settings-icon.svg';
import { ReactComponent as Workflow } from 'assets/svg/workflow-icon.svg';
import { ReactComponent as Keyword } from 'assets/svg/keyword-icon.svg';
import { ReactComponent as QR } from 'assets/svg/qr-scan-icon.svg';
import { ReactComponent as Message } from 'assets/svg/message-icon.svg';
import { ReactComponent as Mail } from 'assets/svg/email-icon.svg';
import { ReactComponent as Reminder } from 'assets/svg/notification-icon.svg';
import { ReactComponent as Send } from 'assets/svg/sent-icon.svg';
import { ReactComponent as Subject } from 'assets/svg/subject-icon.svg';
import { ReactComponent as Mobile } from 'assets/svg/mobile-icon.svg';
import { ReactComponent as Help } from 'assets/svg/help-icon.svg';
import { ReactComponent as Users } from 'assets/svg/users-icon.svg';
import { ReactComponent as User } from 'assets/svg/user.svg';
import { ReactComponent as Notification } from 'assets/svg/notification-icon.svg';
import { ReactComponent as Filter } from 'assets/svg/filter-icon.svg';
import { ReactComponent as Archive } from 'assets/svg/archive-icon.svg';
import { ReactComponent as EmailOpen } from 'assets/svg/email-read-icon.svg';
import { ReactComponent as OptOut } from 'assets/svg/optout-icon.svg';
import { ReactComponent as OptIn } from 'assets/svg/optin-icon.svg';
import { ReactComponent as Profile } from 'assets/svg/profile-icon.svg';
import { ReactComponent as UnArchive } from 'assets/svg/unarchive-icon.svg';
import { ReactComponent as SortDesc } from 'assets/svg/sort-descending.svg';
import { ReactComponent as SortAsc } from 'assets/svg/sort-ascending.svg';
import { ReactComponent as Inbox } from 'assets/svg/inbox-icon.svg';
import { ReactComponent as Pending } from 'assets/svg/pending-icon.svg';
import { ReactComponent as Expand } from 'assets/svg/expand-icon.svg';
import { ReactComponent as Collapse } from 'assets/svg/collapse-icon.svg';
import { ReactComponent as Youtube } from 'assets/svg/youtube.svg';
import { ReactComponent as Search } from 'assets/svg/search_icon.svg';
import { ReactComponent as CallTransfer } from 'assets/svg/call-tansfer.svg';
import { ReactComponent as CallResume } from 'assets/svg/call-resume-icon.svg';
import { ReactComponent as WFReport } from 'assets/svg/wf-report-icon.svg';
import { ReactComponent as MapClock } from 'assets/svg/map-clock-icon.svg';
import { ReactComponent as ClockFast } from 'assets/svg/clock-fast.svg';
import { ReactComponent as AIButton } from 'assets/svg/ai-icon.svg';

const withSvg = (Icon) => (props) =>
  (
    <SvgIcon fontSize="small" {...props}>
      <Icon />
    </SvgIcon>
  );

export const EditIcon = withSvg(Edit);
export const DeleteIcon = withSvg(Delete);
export const GroupIcon = withSvg(Group);
export const PeopleIcon = withSvg(People);
export const SettingsIcon = withSvg(Settings);
export const WorkflowIcon = withSvg(Workflow);
export const QRIcon = withSvg(QR);
export const KeywordIcon = withSvg(Keyword);
export const MessageIcon = withSvg(Message);
export const MailIcon = withSvg(Mail);
export const EmailIcon = withSvg(Mail);
export const ReminderIcon = withSvg(Reminder);
export const SendIcon = withSvg(Send);
export const SubjectIcon = withSvg(Subject);
export const MobileIcon = withSvg(Mobile);
export const HelpIcon = withSvg(Help);
export const UserIcon = withSvg(User);
export const UsersIcon = withSvg(Users);
export const NotificationIcon = withSvg(Notification);
export const FilterIcon = withSvg(Filter);
export const ArchiveIcon = withSvg(Archive);
export const EmailOpenIcon = withSvg(EmailOpen);
export const OptOutIcon = withSvg(OptOut);
export const OptInIcon = withSvg(OptIn);
export const ProfileIcon = withSvg(Profile);
export const UnArchiveIcon = withSvg(UnArchive);
export const SortDescIcon = withSvg(SortDesc);
export const SortAscIcon = withSvg(SortAsc);
export const InboxIcon = withSvg(Inbox);
export const PendingIcon = withSvg(Pending);
export const ExpandIcon = withSvg(Expand);
export const CollapseIcon = withSvg(Collapse);
export const YoutubeIcon = withSvg(Youtube);
export const SearchIcon = withSvg(Search);
export const CallTransferIcon = withSvg(CallTransfer);
export const CallResumeIcon = withSvg(CallResume);
export const WFReportIcon = withSvg(WFReport);
export const MapClockIcon = withSvg(MapClock);
export const ClockFastIcon = withSvg(ClockFast);
export const AIButtonIcon = withSvg(AIButton);
